import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

const ArtifactSections: FC<React.PropsWithChildren<ArtifactSectionsProps>> = ({
  children,
  withMargin = true,
  justifyContent = 'flex-start',
}) => {
  const { classes, cx } = useStyles();
  return (
    <div
      className={cx(classes.sections, withMargin && classes.withMargin)}
      style={{ justifyContent }}>
      {children}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  sections: {
    display: 'flex',
    gap: theme.spacing(3, 2),
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    '& > div': {
      minWidth: '150px',
      borderInlineEnd: `1px solid ${theme.palette.divider}`,
      paddingInlineEnd: theme.spacing(2),
    },
    '& > div:last-of-type': {
      borderInlineEnd: 'none',
    },
  },
  withMargin: {
    marginBlockStart: theme.spacing(3),
  },
}));

interface ArtifactSectionsProps {
  withMargin?: boolean;
  justifyContent?: string;
}

export default ArtifactSections;
